import { ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';
import { buttonTypes } from '../../constants/commonenums';
//import { buttonTypes, InputImages } from '../../constants/commonenums';


export interface FieldConfig {
  minTime?: string;
  disabled?: boolean;
  buttonType?: string;
  label?: string;
  name: string;
  options?: any[];
  autoOptions?: any[];
  placeholder?: string;
  type: string;
  validation?: ValidatorFn[];
  value?: any;
  class?: any;
  changeEvent?: any;
  hide?: boolean;
  showErrorText?: boolean;
  maxDate?: any;
  minDate?: any;
  autocomplete?: string;
  autocompleteOptions?: any[];
  inputType?: string;
  maxLengthHint?: boolean;
  maxLengthCount?: number;
  maxLengthText?: string;
  function?: any;
  panelClass?: string;
  allowDuplicate?: boolean;
  iClass?: string;
  hintText?: string;
  hintRight?: boolean;
  hint?: boolean;
  directive?: any;
  inputClassName?: any;
  returnFunction?: (event) => {};
  cellClick?: (event, ctrlName?) => {};
  blurClick?: (event) => {};
  icon?: string;
  icon1?: string;
  charLength?: number;
  showHint?: boolean;
  showNumbers?: boolean;
  appearance?: boolean;
  showNavigation?: boolean;
  multipleChip?: boolean;
  addBtnConfig?: FieldConfig;
  errorMessage?: string;
  isTranslate?: boolean;
  isPhoneNumber?: boolean;
  id?: number;
  isDateTime?: boolean;
  checked?: boolean;
  min?: number;
  pattern?: any;
  formInputIcon?: string;
  showIconAlways?: boolean;
  partySize?: boolean;
  isTooltip?: boolean;
  isNewPhoneNumber?: boolean;
  isConciergeNumber?: boolean;
  onfocusOutClick?: (event, ctrlName?) => {};
  multiSelectvalue?: any[];
  groupLabel?: string;
  isFormArray: boolean;
  inputControls?: boolean;
  increaseDisabled?: boolean;
  decreaseDisabled?: boolean;
  decreaseClicked?: (event, ctrlName?) => {};
  increaseClicked?: (event, ctrlName?) => {};
  innerHTMLdata?: boolean;
  toolTip?: string;
  disableSelect?: boolean;
  selectValue?: any;
  multiCheck?: boolean;
  prefix?: any;
  isMandatory?: boolean;
  showOption?: boolean;
  FrequencyTypeIds ?:any;
  isNativeControl?: boolean;
  appearanceOutline?:boolean;
  numberFormat?:string;
}
export interface ButtonValue {
  label?: any;
  type: buttonTypes;
  disbaledproperity?: any;
  customclass?: string;
  icon?: string;
  additionalText?: string;
  customStyle?: string;
}

export interface MessageInfo {
  message: string,
  alert?: boolean;
}

export interface FloorPlanImagesDto {
  LayoutImages: InputImages[];
  ObjectImages: InputImages[];
  CustomImages: InputImages[];
}

export enum BookingChargeType
{
    Tax,
    ServiceCharge,
    Negotiation,
    MinRateCoverTypeAdjustment,
    BasePrice,
    Location,
    Staff,
    /// <summary>
    /// Guest type
    /// </summary>
    CoverType,
    BookingType,
    Addon,
    SpecialMeal,
    SpecialMealCovers,
    MembershipDiscount,
    AdditionalRate,
    CancellationFee,
    NoShowFee,
    MembershipRound,
    PackageDiscount,
    PromoCodeDiscount

}

export interface InputImages {
  ImageId: string;
  bytes: string;
  isImageSelected?: boolean;
}

export interface DropDownConfig {
  id: any;
  value: string | number;
}[];


